import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { partnerLicenseSummarySchema } from '../schemas/partner-license-summary.schema';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get the Partner License Summary
 * @returns The Partner License Summary
 */
export function getResellerReportsLicensesSummary(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).resellerReportsLicenseSummaryUrl}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
        }
      )
    )
  ).pipe(selectData(partnerLicenseSummarySchema));
}
